export default {
  namespaced: true,
  
  state: {
    alerts: [],
    autoClose: true,
    autoCloseMs: 5000,

    // cmp alerts
    cmp_alerts: [],
    cmp_autoClose: true,
    cmp_autoCloseMs: 3000,
  },
  
  getters: {
    alerts: state => state.alerts,
    autoClose: state => state.autoClose,

    // cmp alerts
    alertsCmp: state => state.cmp_alerts,
    autoCloseCmp: state => state.cmp_autoClose,
  },

  mutations: {
    success(state, message) {
      state.alerts.push({ type: 'success', message: message });
    },
    error(state, message) {
      state.alerts.push({ type: 'danger', message: message });
    },
    info(state, message) {
      state.alerts.push({ type: 'info', message: message });
    },
    clear(state, index) {
      if (index >= 0) state.alerts.splice(index, 1);
      else state.alerts = [];
    },
    setAutoClose(state, autoClose) {
      if (autoClose) {
        state.autoClose = setTimeout(() => {
          state.alerts = [];
        }, state.autoCloseMs);
      }
      else if (state.autoClose) {
        clearTimeout(this.autoClose);
      }
    },

    // cmp alerts
    successCmp(state, message) {
      state.cmp_alerts.push({ type: 'success', message: message });
      setTimeout(() => {
        state.cmp_alerts.pop();
      }, state.cmp_autoCloseMs);
    },
    errorCmp(state, message) {
      state.cmp_alerts.push({ type: 'danger', message: message });
    },
    infoCmp(state, message) {
      state.cmp_alerts.push({ type: 'info', message: message });
    },
    clearCmp(state, index) {
      if (index >= 0) state.cmp_alerts.splice(index, 1);
      else state.cmp_alerts = [];
    },
    setAutoCloseCmp(state, autoClose) {
      if (autoClose) {
        state.cmp_autoClose = setTimeout(() => {
          state.cmp_alerts = [];
        }, state.cmp_autoCloseMs);
      }
      else if (state.cmp_autoClose) {
        clearTimeout(this.cmp_autoClose);
      }
    },
  },

  actions: {
    //
  }
};